var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-suggestion"},[(_vm.isShowAlways || _vm.isShowContent)?_c('div',{staticClass:"add-suggestion__content"},[_vm._t("default")],2):_c('Btn',{on:{"click":_vm.showContent}},[_vm._v(_vm._s(_vm.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }